import { HIGHLIGHT_WRAPPER_ClASSNAME, POPOVER_SELECTOR, POPOVER_TARGET } from '@anm/constants/embed';
import { VideoSizes } from '@anm/hosting-player';
import { FC } from 'react';

import { ContentWrapper, ImageWrapper, ThumbnailImage, Title, Wrapper } from './Wrapper';

type HighLightEmbedProps = {
  sizes: VideoSizes;
  title: string;
  imgSrc: string;
  hostId: string;
  videoName?: string;
};

const HighLightEmbed: FC<HighLightEmbedProps> = ({ sizes, title, imgSrc, hostId, videoName }) => (
  <Wrapper className={POPOVER_SELECTOR} data-id={hostId} data-width={sizes.width} data-height={sizes.height}>
    <ContentWrapper data-target={POPOVER_TARGET}>
      <ImageWrapper className={HIGHLIGHT_WRAPPER_ClASSNAME}>
        <ThumbnailImage src={imgSrc} alt={videoName || title} />
      </ImageWrapper>
      <Title>{title}</Title>
    </ContentWrapper>
  </Wrapper>
);

export default HighLightEmbed;
